import validate from "/builds/rialtic/qa/argocd-releases/console-ui/node_modules/.pnpm/nuxt@3.17.7_a4f1b1580789b7c5082f6b993bd72137/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45rules_45global from "/builds/rialtic/qa/argocd-releases/console-ui/apps/content/middleware/redirect-rules.global.ts";
import _01_45auth_45required_45global from "/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/middleware/auth-required.global.ts";
import manifest_45route_45rule from "/builds/rialtic/qa/argocd-releases/console-ui/node_modules/.pnpm/nuxt@3.17.7_a4f1b1580789b7c5082f6b993bd72137/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45rules_45global,
  _01_45auth_45required_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-content-admin": () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/content/middleware/is-content-admin.ts")
}